module.exports = __webpack_public_path__ + "static/media/YF46_1.07f35028.jpg";